import BotonGeneral from './BotonGeneral'

export default BotonGeneral
